import {computed, onMounted, ref} from 'vue'
import store from "../store"
import helpers from "./helpers";

export function useModel(type, url) {
    const local = ref()
    const method = (url instanceof Object) ? (url.method || 'GET') : 'GET'
    const href = (url instanceof Object) ? url.href : url
    type = Array.isArray(type) ? type : [type]

    const refresh = async () => {
        if (href)
            local.value = await helpers.asyncAction(href, 'GET')
        else
            store.dispatch('record_load')
    }

    onMounted(async () => {
        if (href)
            local.value = await helpers.asyncAction(href, 'GET')
    })

    const model = computed(() => {
        return local.value || (type.includes(store.state.record.type) && store.state.record.active)
    })

    return {model, refresh}
}